import React from 'react';
import * as Yup from 'yup';

import { MultimediaValues } from '../../../../../features/multimedia/model/multimediaModel';
import DialogForm from '../../../base/DialogForm';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../enum/formProps';

import './SelectFileForm.scss';
import TextField from '../../TextField';

const initialValues: MultimediaValues = {
  file: '',
};

const validationSchema = Yup.object().shape({
  file: Yup.string()
    .matches(/^\/api\/media_objects\/[0-9]{1,10}$/g, 'validation.iri_regex')
    .required('validation.is_required'),
});

interface UploadFileFormProps {
  onClose: () => void;
  onSuccess: (iri: string) => void;
  buttonActionLabel: string;
}

const UploadFileForm: React.FC<UploadFileFormProps> = (props) => {
  return (
    <DialogForm
      buttonActionLabel={props.buttonActionLabel}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: MultimediaValues) => {
        props.onSuccess(values.file as string);
      }}
      onClose={props.onClose}
    >
      <TextField
        className="SelectFileForm-File"
        name="file"
        label="multimedia.file_iri"
        type={TEXT_FIELD_TYPE.TEXT}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
    </DialogForm>
  );
};

export default UploadFileForm;
